import React from 'react';
import { Box, Typography } from '@mui/material';
import { setDocument, useDocument, useSelectedBlockId } from '../../../documents/editor/EditorContext';
import EmailLayoutSidebarPanel from './input-panels/EmailLayoutSidebarPanel';
function renderMessage(val) {
    return (React.createElement(Box, { sx: { m: 3, p: 1, border: '1px dashed', borderColor: 'divider' } },
        React.createElement(Typography, { color: "text.secondary" }, val)));
}
import BLOCKS from '../../../Packages/blocks';
const blockMap = Object.fromEntries(BLOCKS.map((b) => [b.type, b.SidebarPanel]));
export default function ConfigurationPanel() {
    const document = useDocument();
    const selectedBlockId = useSelectedBlockId();
    if (!selectedBlockId)
        return renderMessage('Click on a block to inspect.');
    const block = document[selectedBlockId];
    if (!block)
        return renderMessage(`Block with id ${selectedBlockId} was not found.`);
    const setBlock = (conf) => setDocument({ [selectedBlockId]: conf });
    //For the time being this block doesn't need its own package
    if (block.type === 'EmailLayout') {
        const { data, type } = block;
        return React.createElement(EmailLayoutSidebarPanel, { key: selectedBlockId, data: data, setData: (data) => setBlock({ type, data }) });
    }
    const BlockPanel = blockMap[block.type];
    const { data, type } = block;
    return BlockPanel ? React.createElement(BlockPanel, { key: selectedBlockId, data: data, setData: (data) => setBlock({ type, data }) }) : React.createElement("pre", null, JSON.stringify(block, null, '  '));
}
//# sourceMappingURL=index.js.map